// extracted by mini-css-extract-plugin
export default {"page":"Ai-z","cartModal":"Bi-z","checkout":"Ci-z","placeholder":"Di-z","account":"Ei-z"};